import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Provider } from 'react-redux';
import { RhumbProvider } from 'react-rhumb';
import historyAdapter from 'react-rhumb/historyAdapterV4';
import { Router } from 'react-router-dom';
import rhumbConfig from '../../rhumb-config.yaml';
import ResponsivenessProvider from '../responsiveness/ResponsivenessProvider';
import { GlobalStyle } from './GlobalStyles.styles';
import Routes from './Routes';
export default function AppComponent({
  store,
  history
}) {
  return /*#__PURE__*/_jsxs(Provider, {
    store: store,
    children: [/*#__PURE__*/_jsx(GlobalStyle, {}), /*#__PURE__*/_jsx(RhumbProvider, {
      captureExceptions: true,
      config: rhumbConfig,
      history: historyAdapter(history),
      children: /*#__PURE__*/_jsx(ResponsivenessProvider, {
        children: /*#__PURE__*/_jsx(Router, {
          history: history,
          children: /*#__PURE__*/_jsx(Routes, {})
        })
      })
    })]
  });
}